<template>
<div>
  <ErrorPlankk />
  <ComingSoon />
  <CopyToClipboardModal />
  <NoLeftoversModal v-if="this.currentUser" />
  <RecipeDetailFull
    v-if="this.currentUser && this.recipeDetailFull && this.el.is.tabletUp && onboardingEnabled"
    :isEmbed="this.isEmbed"
    :onTabletUp="el.is.tabletUp"
    :data="this.recipeDetailFull"
    :deepLink="this.recipeDetailFull.deepLink"
  />
  <DishFilters :onTabletUp="el.is.tabletUp" v-if="this.currentUser && !this.el.is.tabletUp && onboardingEnabled" />
  <RecipeSource v-if="this.currentUser && onboardingEnabled" />
  <PrimaryHeader :isEmbed="this.isEmbed" :onTabletUp="el.is.tabletUp" v-if="this.currentUser && this.el.is.tabletUp && onboardingEnabled" />

  <b-container fluid :class="[$style.container, pageClass]">
    <b-row class="parent-row">
      <GroceryList
        :isEmbed="this.isEmbed"
        :onTabletUp="el.is.tabletUp"
        v-if="this.currentUser && this.el.is.tabletUp && currentPrimaryView && currentPrimaryView.component === null && onboardingEnabled"
      />
      <b-col :class="$style.bodyContainer" :style="{ overflow: pageClass == 'recipes' ? 'hidden' : 'scroll' }">
        <slot />
      </b-col>
    </b-row>
  </b-container>

  <PlanGridEmpty :onTabletUp="el.is.tabletUp" v-if="currentPrimaryView && currentPrimaryView.component === null && onboardingEnabled" />

  <!-- Mobile Drawer -->
  <KitchenDrawer :onTabletUp="el.is.tabletUp" v-if="this.currentUser && !this.el.is.tabletUp && onboardingEnabled" />

  <!-- Desktop Drawer -->
  <!-- <scale-transition :origin="this.drawerOrigin" :duration="300"> -->
  <KitchenDrawer :onTabletUp="el.is.tabletUp" v-if="this.currentUser && this.el.is.tabletUp && this.isOpen" />
  <!-- </scale-transition> -->
</div>
</template>

<script>
import DishFilters from 'DishFilters/DishFilters';
import KitchenDrawer from 'KitchenDrawer/KitchenDrawer';
import NoLeftoversModal from 'Modals/NoLeftoversModal';
import ComingSoon from 'Modals/ComingSoon';
import CopyToClipboardModal from 'Modals/CopyToClipboardModal';
import PlanGridEmpty from 'PlanGrid/PlanGridEmpty';
import PrimaryHeader from 'PrimaryHeader/PrimaryHeader.vue';
import GroceryList from 'GroceryList/GroceryList';
import RecipeDetailFull from 'RecipeDetail/RecipeDetailFull';
import ErrorPlankk from 'Modals/ErrorPlankk';
import RecipeSource from 'RecipeDetail/RecipeSource';
import { breakpointsMixin } from 'breakpointsMixin';
import { ScaleTransition } from 'vue2-transitions';
import {
  authComputed,
  kitchenDrawerComputed,
  primaryNavComputed,
  recipesComputed,
  mainMethods,
  onboardingComputed,
  userComputed,
  userMethods,
  planComputed,
  planMethods,
} from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {
    ComingSoon,
    CopyToClipboardModal,
    DishFilters,
    GroceryList,
    ErrorPlankk,
    KitchenDrawer,
    NoLeftoversModal,
    PlanGridEmpty,
    PrimaryHeader,
    RecipeDetailFull,
    RecipeSource,
    ScaleTransition,
  },
  data() {
    return {
      isEmbed: true,
    };
  },
  computed: {
    ...authComputed,
    ...kitchenDrawerComputed,
    ...onboardingComputed,
    ...primaryNavComputed,
    ...recipesComputed,
    ...userComputed,
    ...planComputed,
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    onboardingEnabled() {
      if (this.isOnboardingEnabled && this.userProfile.onboardingComplete) {
        return true;
      } else if (this.loggedIn && !this.isOnboardingEnabled && this.$route.name !== 'login') {
        return true;
      } else {
        return false;
      }
    },
    pageClass() {
      const currentComponent = this.currentPrimaryView.component;
      return currentComponent ? currentComponent.toLowerCase() : '';
    },
    drawerOrigin() {
      return this.drawerTransitionOrigin;
    },
  },
  async beforeMount() {
    this.toggleLoader();
    if (this.loggedIn) {
      await this.getUserProfile();
      if (this.isOnboardingEnabled && !this.userProfile.onboardingComplete) {
        this.$router.push({ name: 'onboarding' });
      }
    }
  },
  async mounted() {
    if (this.loggedIn) {
      await this.getPlanGrid();
      await this.verifyEmptyPlan();
    }
    window.history.replaceState(null, null, location.href);
    window.onpopstate = function(event) {
      history.go(1);
    };
    setTimeout(() => this.hideLoader(), 2000);
  },
  methods: {
    ...mainMethods,
    ...userMethods,
    ...planMethods,
    toggleLoader() {
      this.showLoader(this.$t('lblPreparingYourPlan'));

      setTimeout(() => {
        this.updateLoadingText(this.$t('lblPreparingYourPlanDetail'));
      }, 3000);
    },
    verifyEmptyPlan() {
      if (this.dailySummary && this.dailySummary.planDays) {
        this.dailySummary.planDays.forEach((day) => {
          if (
            day.Breakfast.meals.length > 0 ||
            day.Breakfast.recipes.length > 0 ||
            day.Lunch.meals.length > 0 ||
            day.Lunch.recipes.length > 0 ||
            day.Dinner.meals.length > 0 ||
            day.Dinner.recipes.length > 0
          ) {
            if (this.isPlanEmpty) {
              this.setIsPlanEmpty();
              return;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" module>
@import 'theme.scss';

.container {
  max-width: 100vw;
  min-width: 100vw;
}

.bodyContainer {
  height: 100vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  width: calc(100vw - 26rem);
}
</style>
